import ConsentTypes from "./action-types";

export const setConsent = () => ({
  type: ConsentTypes.SET_CONSENT,
});
export const resetConsent = () => ({
  type: ConsentTypes.RESET_CONSENT,
});


